const mapCancelReason = reason => (reason?.reason
    ? ({
        type: reason.reason,
        ...(reason.userTextInputValue ? { freeText: reason.userTextInputValue } : {}),
    })
    : null);

export default mapCancelReason;
